
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/polski-czerwony-krzyz/[slug]",
      function () {
        return require("private-next-pages/polski-czerwony-krzyz/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/polski-czerwony-krzyz/[slug]"])
      });
    }
  